import React, { Suspense } from 'react';

import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import { Route, Router, Switch } from 'wouter';

import AppProviders from './AppProviders';
import Loader from './components/Loader';
import routes from './routes';

// set the locale globally
dayjs.locale('en-gb');

const App = () => (
  <Router>
    <AppProviders>
      <Suspense fallback={<Loader height="100vh" />}>
        <Switch>
          {routes.map(({ path, component }) => (
            <Route key={path} path={path} component={component} />
          ))}
        </Switch>
      </Suspense>
    </AppProviders>
  </Router>
);

export default App;
